<template>
  <div id="app">
    <TheHeader/>
    <main class="flex-grow-1">
      <RouterView/>
    </main>
    <TheFooter/>
  </div>
</template>

<script setup>
import {RouterView} from 'vue-router'
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
</script>

<style lang="scss">
    @import "./sass/app";

    #app {
        h1 {
            text-align: center;
            font-size: 40px;
            color: $thirdcolor;
        }

        h2 {
            font-family: $titlefont;
            color: $thirdcolor;
        }

        h3 {
            font-size: 30px;
            color: $firstcolor;
        }

        h1, h3 {
            font-family: $titlefont;
        }

        h4 {
            font-family: $titlefont;
            color: $thirdcolor;
        }

        p, span {
            font-family: $textfont;
            font-size: 18px;
        }
    }
</style>
